module.exports = __webpack_public_path__ + "img/34.2bc3d94b.jpg";